<template>
  <div>

          <div class="row">

            <div class="paid-payments-action-buttons">
              <div
                  class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
                  @click="synchronisePayments()"
              >
                <i class="fas fa-sync"/>
                Synchronizuj
              </div>

              <div
                  class="d-none d-sm-inline-block btn btn-sm btn-info shadow-sm"
                  style="margin-left: 4px;"
                  @click="exportToCsv()"
              >
                <i class="fas fa-file-excel"/>
                Eksportuj do CSV
              </div>

            </div>

          </div>

    <div :class="generatorMainSectionClass">

      <div class="row">
        <SearchBar2
            :searchOptions="fieldsAvailableForSearch"
            @searchRequest="searchOnList($event)"
        />
      </div>
        <CommonTableFilterSection2 :filters-fetch-method="paymentsModule.httpGetPaymentsAvailableFilters"
                                  :explicit-filters="filtersForCurrentView"
                                  @onSelectedFilters="updateFilters($event)"
        />


      <div class="col paid-payments-checked-items">
        <div v-show="paymentsChecked.length > 0">
          {{ paymentsChecked.length }} zaznaczonych dokumentów do opłacenia na kwotę: {{ getAmountToPay() }}
          PLN <b @click="resetCheckedItems();refreshPaymentsData()" style="cursor:pointer;"> [Wyczyść zaznaczone]</b>
        </div>
      </div>

      <div class="payments-table-container">
        <div>
          <CommonTable2
              :table="tableData"
              :rowIdentifier="rowIdentifierKey"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              :key="refreshTable"
              :currentPage="currentPage"
              :totalRows="paymentsModule.getPaymentsTotal"
              :totalPages="paymentsModule.getPaymentsPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              @onPageChange="currentPage = $event"
              :initiallyCheckedItemsData="paymentsChecked"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
              :initiallyVisibleColumns="['id_dokumentu', 'id_apteki','nazwa_dostawcy','numer_dokumentu','termin_platnosci','wartosc_brutto','suma_platnosci','numer_dok_plat','dg_utw_platnosci_centralnej','typ_platnosci_dok','status','actions']"
              :enableRowSelection="false"
          />
        </div>


      </div>


    </div>
            <b-modal
                v-model="showPaymentDocumentModal"
                id="payment-document-form-modal"
                scrollable
                title="Dokument wypłaty"
                title-class="font-18"
                hide-footer
                size="lg"
                style="z-index:99999!important;"
                @hide="closeDocumentModal()"
            >

              <div class="row">
                <div class="paid-payments-action-buttons">
                  <button
                      v-if="!showPaymentDocumentEditForm"
                      class="d-none d-sm-inline-block btn btn-sm btn-edit shadow-sm"
                      @click="editPaymentDocument()"
                  >
                    <i class="fas fa-edit"/>
                    Edytuj dokument
                  </button>



                  <button
                      class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
                      style="margin-left: 4px;"
                      @click="exportAndSendEmail()"

                  >
                    <i class="fab fa-telegram-plane ms-1"/>
                    Wyślij dokumenty do dostawcy
                  </button>




                </div>


              </div>

              <div class="row">
                <div class="paid-payments-action-buttons">
                  <button
                      class="d-none d-sm-inline-block btn btn-sm btn-info shadow-sm"
                      style="margin-left: 4px;"
                      @click="exportToPDFText()"

                  >
                    <i class="fas fa-file-pdf"/>
                    Eksportuj do PDF
                  </button>

                  <button
                      class="d-none d-sm-inline-block btn btn-sm btn-info shadow-sm"
                      style="margin-left: 4px;"
                      @click="exportDocumentItemsToCsv()"

                  >
                    <i class="fas fa-file-excel"/>
                    Eksportuj dokumenty do CSV
                  </button>

                  <button
                      class="d-none d-sm-inline-block btn btn-sm btn-info shadow-sm"
                      style="margin-left: 4px;"
                      @click="openBankWireGenerator()"

                  >
                    <i class="fas fa-file-invoice-dollar"/>
                    Eksportuj do banku
                  </button>

                </div>
              </div>
              <div v-if="showPaymentDocumentEditForm" style="margin-top: 20px!important;">

                <div class="row">
                  <div class="btn btn-info" @click="showSelectCentralSupplierModal = true">
                    <i class="fas fa-file-import"></i>
                    Importuj dane dostawcy centralnego
                  </div>
                </div>

              <CommonForm id="payment-document-form" :structure="paymentDocumentFormStructure" :data="currentPaymentDocumentFormData"
                          :key="currentPaymentDocumentFormData"
                          @onSubmit="savePaymentDocumentData($event)"
                          @onCancel="cancelPaymentDocumentEdit"
                          submitButtonText="Zapisz" :submitButtonEnabled="true"
                          cancelButtonText="Anuluj" :cancelButtonEnabled="true"
              />

              </div>
            <div v-else>
              <BankWireOrderDocument id="bank-wire-pdf" ref="bank-wire-pdf" :bankWireOrderDocument="currentPaymentDocumentFormData"/>
            </div>

            </b-modal>

    <SupplierListModal  :showModal="showSelectCentralSupplierModal"
                        @update:showModal="showSelectCentralSupplierModal = $event"
                       title="Powiąż z centralną kartoteką dostawcy"
                       ok-title="Powiąż"
                       :multiselect="false" @onApply="importSelectedSupplierData"
                       :showMassActions="false"
                       :showRowActions="false"
                       :showAddButton="false"
    />




    <BankWireModal
        v-if="showBankWireGenerator"
        :banks="banks"
        :paymentDocumentGuid="currentPaymentDocumentFormData.guid"
        @onClose="closeBankWireGenerator"
    />

    <b-modal
        v-model="showSendMailModal"
        id="send-payment-doc-email-form-modal"
        scrollable
        :title=mailContent.sendMailDialogTitle
        title-class="font-18"
        size="xl"
        style="z-index:100010!important;"
        hide-footer


    >
      <b-alert
          v-model="showSendMailAlert"
          :variant="sendMailAlertType"
          class="mt-3"
          dismissible
      >{{ sendMailAlertContent }}
      </b-alert
      >

      <div class="form-group">

        <CommonEmailSendMessageForm
            :mailMessage="mailContent.mailMessage"
            :mailSubject="mailContent.mailSubject"
            :mailTo="mailContent.mailTo"
            :mailCc="mailContent.mailCc"
            :mailAttachmentName="mailContent.mailAttachmentName"
            @onCancelMail="showSendMailModal = false"
            @onSendMail="sendEmailWithPaymentDocumentData"
            :key="mailContent"


        />


      </div>




    </b-modal>
  </div>

</template>


<script>
import CommonTable2 from "@/components/widgets/CommonTable2";
import {BModal} from "bootstrap-vue-next";
import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import Swal from "sweetalert2";
import {log} from "@/state/pinia/log";
import CommonForm from "@/components/widgets/CommonForm.vue";
import {paymentFormFields} from "./data/paymentFormFields";
import {paymentsHelperMethods} from "./helper/paymentsHelperMethods";
import BankWireOrderDocument from "./BankWireOrderDocument.vue";
import jsPDF from "jspdf";
import {jsFonts} from "./data/jsFonts";
import CommonTableFilterSection2 from "@/components/widgets/CommonTableFilterSection2.vue";
import SupplierListModal from "@/views/DrugstoreCommonManager/SupplierListModal.vue";
import BankWireModal from "./BankWireModal.vue";
import CommonEmailSendMessageForm from "@/components/widgets/CommonEmailSendMessageForm.vue";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {usePaymentsManagerModule} from "@/state/pinia/paymentsManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import html2pdf from "html2pdf.js";
import {useLayoutStore} from "@/state/pinia/layout";


export default {
  name: "PaidPaymentsStage",
  props: {
    displayInBootstrapRow: {
      type: Boolean,
      default: () => false
    },
  },
  components: {
    CommonEmailSendMessageForm,
    BankWireModal,
    SupplierListModal,
    CommonTableFilterSection2,
    BankWireOrderDocument,
    BModal,
    CommonForm,
    // BModal,
    SearchBar2,
    // PaymentConfirmationModal,
    CommonTable2
  },
  data() {
    return {
      rowIdentifierKey: "unique_global_doc_id",
      paymentsForItemsRowIdentifier: "id_dokumentu_plat",
      tableData: {},
      paymentDocumentsMap: {},
      itemsChecked:[],
      paymentsChecked: [],
      currentPage: 1,
      sortingDirection: "DESC",
      sortingKey: "dg_utw_platnosci_centralnej",
      searchRequest: {
        searchPhrase: null,
        searchKey: null,
      },
      paymentsRows: [],
      availableHeaders: [],
      tableMassActions: [
        {
          text: "Wystaw dokumenty wypłaty",
          icon: "fas fa-file-invoice",
          action: "create-payments-documents",
          class: "btn btn-success mass-operations-btn",
          enabled: true,
        },
      ],
      rowActions: [
        {
          text: "",
          icon: "fas fa-money-bill-wave",
          action: "view-payments",
          class: "btn btn-info table-actions-button edit-button",
          enabled: true,
          tooltip: "Zobacz płatności",

        },


      ],

      fieldsAvailableForSearch: [],
      paidStatus: "PAID",
      paymentsListForItemTableData: {},
      refreshTable: true, //added key to force re-rendering
      showPaymentDocumentModal: false,
      showPaymentDocumentEditForm: false,
      paymentDocumentFormStructure: paymentFormFields.paymentDocumentForm,
      currentPaymentDocumentFormData: {},
      emptyPaymentDocumentFormData:{
        guid: null,
        documentNumber: null,
        documentType: null,
        documentIssueDateTime: null,
        documentValue: null,
        documentCurrency: "PLN",
        receiverName: null,
        receiverAccountNumber: null,
        receiverBankName: null,
        receiverAddress: null,
        receiverNip: null,
        payerName: null,
        payerAccountNumber: null,
        payerBankName: null,
        payerAddress: null,
        payerNip: null,
        paymentTitle: null,
      },
      selectedFilters: [],
      checkedItemsPayValueOnPages:0.0,
      filtersForCurrentView:["nip_apteki", "id_apteki","nazwa_apteki", "nip", "nazwa_dostawcy", "termin_platnosci","wartosc_brutto","wartosc_pozycji_brutto", "numer_dok_plat","typ_platnosci_dok"],
      showSelectCentralSupplierModal: false,
      selectedCentralSuppliersGuidToImport:null,
      showBankWireGenerator:false,
      banks: [],
      mailContent:{
        sendMailDialogTitle: "",
        mailMessage:"" ,
        mailSubject: "",
        mailTo: "",
        mailCc:"",
        mailAttachmentName:""
      },
      showSendMailModal: false,
      showSendMailAlert:false,
      sendMailAlertType: "warning",
      sendMailAlertContent: "",


    };
  },
  computed: {
    paymentsModule(){
      return usePaymentsManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
    layoutStore() {
      return useLayoutStore();
    },

    layout: {
      get() {
        return this.layoutStore.layoutType;
      },
      set(layout) {
        this.layoutStore.changeLayoutType(layout);
      }

    },

    generatorMainSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'row payments-table-container';
      } else {
        return 'payments-table-container';
      }
    },
  },
  methods: {

    exportAndSendEmail(){
      paymentsHelperMethods.exportDocumentItemsToFile(this.currentPaymentDocumentFormData.guid,"CSV",true,false).then((response)=>{
        log.log(response);
        if(response.isConfirmed){
          this.mailContent = {
            sendMailDialogTitle: response.sendMailDialogTitle,
            mailMessage: response.mailMessage,
            mailSubject: response.mailSubject,
            mailTo: response.mailTo,
            mailCc:response.mailCc,
            mailAttachmentName: response.mailAttachmentName
          }

          const messageAlreadySentForThisDocument = this.currentPaymentDocumentFormData.sentMessageHistory
          if(messageAlreadySentForThisDocument && messageAlreadySentForThisDocument.sent === true){
            this.showSendMailAlert = true;
            this.sendMailAlertType = "warning";
            this.sendMailAlertContent = "Wiadomość email z dokumentem została już wysłana do dostawcy dnia " + paymentsHelperMethods.formatDatetimeToLocaleFormat(messageAlreadySentForThisDocument.sendDate);
          }

          this.showSendMailModal = true;

        }
      });
    },
    sendEmailWithPaymentDocumentData(emailData){
      log.log(emailData);
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Wysyłanie wiadomości email z listą dokumentów...");

      var emailPayload = {
        mailMessage: emailData,
        paymentDocumentGuid: this.currentPaymentDocumentFormData.guid
      }

      this.paymentsModule.httpSendEmailWithPaymentDocumentData(emailPayload).then((response) => {
        this.showSendMailModal = false;
        return apiRequestsHelper.handleResponseWithDialogs(response, true);
      })
          .catch((error) => {
            return apiRequestsHelper.catchResponseError(error,"httpSendEmailWithPaymentDocumentData");
          });
    },

    openBankWireGenerator(){
      if(this.currentPaymentDocumentFormData && this.currentPaymentDocumentFormData.documentValue && (this.currentPaymentDocumentFormData.documentValue < 0 || this.currentPaymentDocumentFormData.documentValue === 0)){
        Swal.fire({
          title: "Nieprawidłowa wartość dokumentu",
          text: "Nie można wyeksportować do formatu bankowego dokumentu z ujemną lub równą 0 wartością.",
          icon: "error",
          customClass: {
            container: "swal-highest"
          },

        })
        return
      }

      this.showBankWireGenerator = true;
    },
    closeBankWireGenerator(){
      this.showBankWireGenerator = false;
    },
    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.refreshPaymentsData();
    },
    saveGlobalCheckedItems(event){
      log.log("event",event);
      this.paymentsChecked = event.itemsData;
      this.checkedItemsPayValueOnPages = this.paymentsChecked.map(item=>item["wartosc_brutto"]).reduce((a, b) => a + b, 0);
    },
    resetCheckedItems(){
      this.checkedItemsPayValueOnPages = 0.0;
      this.paymentsChecked = [];
    },
    runAction(event) {
      if (event.action.action === "create-payment-document") {
        this.createPaymentsDocuments([event.itemData]);
      } else if (event.action.action === "view-payments") {
        paymentsHelperMethods.showPaymentsModal(event.itemData, this.paymentsForItemsRowIdentifier);
      } else if(event.action.action === "view-payment-document"){

        var rowIdentifier = event.itemData[this.rowIdentifierKey];
        var documentsFound = this.paymentDocumentsMap[rowIdentifier]; // there should be always only one document (if any exists), but we fetch an array from backend because theoretically there could be more than one document for one payment when we include removed payment documents
        if(documentsFound.length > 0){
          this.currentPaymentDocumentFormData =  JSON.parse(JSON.stringify(documentsFound[0]));
          // formating document issue date from timestamp to date string
          this.currentPaymentDocumentFormData["documentIssueDateTime"] = paymentsHelperMethods.formatDateToISO(this.currentPaymentDocumentFormData["documentIssueDateTime"]);


          // block some of the fields in form structure, because we want to show them as read-only (not to update)
          // documentNumber, documentType,documentIssueDateTime and documentValue should not be updatable
          // this.paymentDocumentFormStructure is an array we have to iterate by every item to iterate on the fields array
          // also we have to make copy to avoid changing the original structure

          var paymentDocumentFormStructureCopy = JSON.parse(JSON.stringify(this.paymentDocumentFormStructure));

          for (var i = 0; i < paymentDocumentFormStructureCopy.length; i++) {
            if(paymentDocumentFormStructureCopy[i].fields !== undefined){
              for (var j = 0; j < paymentDocumentFormStructureCopy[i].fields.length; j++) {
                if(paymentDocumentFormStructureCopy[i].fields[j].name === "documentNumber" || paymentDocumentFormStructureCopy[i].fields[j].name === "documentType" || paymentDocumentFormStructureCopy[i].fields[j].name === "documentIssueDateTime" || paymentDocumentFormStructureCopy[i].fields[j].name === "documentValue"){
                  paymentDocumentFormStructureCopy[i].fields[j].disabled = true;
                }
              }
            }
          }

          this.paymentDocumentFormStructure = paymentDocumentFormStructureCopy;
          this.showPaymentDocumentModal = true;
        }else{
          Swal.fire({
            title: "Brak dokumentu wypłaty",
            text: "Dla wybranej płatności nie istnieje dokument wypłaty",
            icon: "info",
            confirmButtonText: "OK",
          });
        }


      }

    },

    runMassAction(event) {
      log.log(event);
      if (event.action.action === "create-payments-documents") {
        this.createPaymentsDocuments(this.paymentsChecked);
      }
    },
    sort(sortKey) {
      log.log(sortKey);
      this.sortingKey = sortKey;
      this.refreshPaymentsData();
      this.toggleSortingDirection();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    checkAction(event) {
      log.log(event.itemsData);
      this.saveGlobalCheckedItems(event);
    },
    refreshPaymentsData() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie danych o płatnościach.");
      this.paymentsRows = JSON.parse(JSON.stringify(this.paymentsModule.getPayments));

      return this.paymentsModule.httpGetPaymentHeaders().then(() => {
        this.availableHeaders = JSON.parse(JSON.stringify(this.paymentsModule.getPaymentsHeaders));
        this.refreshPaymentsList();
      });
    },
    refreshFieldsAvailableForSearch() {
      this.fieldsAvailableForSearch = [];
      this.paymentsModule.httpGetPaymentSearchKeys().then(() => {
        var searchKeysFetched = JSON.parse(JSON.stringify(this.paymentsModule.getPaymentsSearchKeys));


        var tableColumnsAvailableForSearch = this.availableHeaders.filter(header => searchKeysFetched.includes(header.key) && header.type === "text");
        for (var i = 0; i < tableColumnsAvailableForSearch.length; i++) {
          this.fieldsAvailableForSearch.push({
            name: this.paymentsModule.paymentsVisibleHeadersTitlesMap[tableColumnsAvailableForSearch[i].key],
            key: tableColumnsAvailableForSearch[i].key
          });
        }

      });
    },
    getShowPaymentDocumentActionClass(row) {
      var rowIdentifier = row[this.rowIdentifierKey];
      var paymentDocument = this.paymentDocumentsMap[rowIdentifier];
      if (paymentDocument == null || paymentDocument.length === 0) {
        return "element-not-visible";
      } else {
        return "btn btn-info table-actions-button edit-button";
      }
    },
    getCreatePaymentDocumentActionClass(row) {
      var rowIdentifier = row[this.rowIdentifierKey];
      var paymentDocument = this.paymentDocumentsMap[rowIdentifier];
      if (paymentDocument == null || paymentDocument.length === 0) {
        return "btn btn-success table-actions-button edit-button";
      } else {
        return "element-not-visible";
      }
    },

    refreshPaymentsList() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie listy płatności.");
      this.paymentsModule.setPayments([])
      this.paymentsModule.setPaymentDocumentsMapForCurrentRows({})
      // this.currentTaskId = this.$route.params.taskId;


      this.searchAndFilterRequest = {
        fields: null,
        search: this.searchRequest,
        filters: this.selectedFilters
      }

      var payload = {
        searchAndFilterRequest: this.searchAndFilterRequest,
        currentPage: this.currentPage,
        sortingDirection: this.sortingDirection,
        sortingKey: this.sortingKey,
        paidStatus: this.paidStatus

      };
      this.refreshTable = false;
      this.paymentsModule.httpGetPaymentsDataPaging(payload).then(() => {

        this.paymentsRows = [];
        var payments = JSON.parse(JSON.stringify(this.paymentsModule.getPayments));
        for (var i = 0; i < payments.length; i++) {
          payments[i]["data_utworzenia"] = paymentsHelperMethods.formatDateToLocale(payments[i]["data_utworzenia"]);
          payments[i]["termin_platnosci"] = paymentsHelperMethods.formatDateToLocale(payments[i]["termin_platnosci"]);
          payments[i]["typ_platnosci_dok"] = payments[i]["typ_platnosci_dok"] === 3;
          if(payments[i]["wartosc_brutto"] === 0){
            payments[i]["wartosc_brutto"] = payments[i]["wartosc_pozycji_brutto"]
          }

          payments[i]["dg_utw_platnosci_centralnej"] = paymentsHelperMethods.formatDatetimeToLocaleFormat(payments[i]["dg_utw_platnosci_centralnej"]);
          payments[i]["tooltip"] = this.commonModule.getDrugstoresNameMap[payments[i]["id_apteki"]];

          // payments[i]["row-class"] = this.getRowClass(payments[i]);


          const paymentsStatesForGeneratedPayments =  payments[i]["status_platnosci"]

          if(paymentsStatesForGeneratedPayments == null){ // means there is no temporary data for this payment so the payment is synchronised
            payments[i]["status"] = "fas fa-check";
          }else if(paymentsStatesForGeneratedPayments.includes("CREATED")) {
            payments[i]["status"] = "fas fa-sync-alt"
          }else {
            payments[i]["status"] = "fas fa-question"
          }


          payments[i][this.rowIdentifierKey] = payments[i]["id_dokumentu"] + "#" + payments[i]["id_apteki"];


          this.paymentsRows.push(payments[i]);
        }
        this.lazyloaderModule.setDisplayLazyLoader(true);
        this.lazyloaderModule.setProgressBarMessage("Ładowanie listy");

        var rowIdentifierKeysPayload = {
          rowsIds: this.paymentsRows.map(row => row[this.rowIdentifierKey])
        }
        this.paymentsModule.httpGetPaymentDocumentsMap(rowIdentifierKeysPayload).then(() => {
          this.paymentDocumentsMap = JSON.parse(JSON.stringify(this.paymentsModule.getPaymentDocumentsMapForCurrentRows));

          var paymentsHeaders = []

          var paidPaymentsHeaders = JSON.parse(JSON.stringify(this.paymentsModule.getPaymentsVisibleHeaders));
          paidPaymentsHeaders.push('numer_dok_plat');
          paidPaymentsHeaders.push('dg_utw_platnosci_centralnej');



          for (var j = 0; j < paidPaymentsHeaders.length; j++) {
            var header = this.availableHeaders.find(header => header.key === paidPaymentsHeaders[j]);
            log.log(header);
            if (header !== undefined) {
              header["text"] = this.paymentsModule.paymentsVisibleHeadersTitlesMap[paidPaymentsHeaders[j]];
              if (header.key === "typ_platnosci_dok") {
                header.type = "boolean";
              }
              // setting type on id_dockumentu and id_apteki column to number style
              if(header.key === "id_dokumentu" || header.key === "id_apteki"){
                header["class"] = "sticky-header col-number";
              }

              if(header.key === "numer_dokumentu"){
                header["class"] = "col-mid-text";
              }

                if(header.key === "numer_dok_plat"){
                  header["style"] = "width:50px;";
              }



              if ( header.key === "nazwa_dostawcy") {
                header["style"] = "width:300px;text-align:left;padding-left:16px;padding-right:16px;";
              }
              paymentsHeaders.push(header);
            }
          }

          paymentsHeaders.push(
              {
                text: "St",
                key: "status",
                type: "icon",
                style: "cursor:pointer;width:20px;text-align:center",
                sortable:false,
                contentClass:"icon-center icon-success",
                preventCopying:true

              },
              {
                text: "Akcje",
                key: "actions",
                type: "actions",
                style: "cursor:pointer;",
                sortable:false,
                preventCopying:true,
                actions: this.rowActions

              }

          );

          // adding row actions
          for (var k = 0; k < this.paymentsRows.length; k++) {
            this.paymentsRows[k]["actions"] = [
              {
                text: "",
                icon: "fas fa-file-invoice", //Dokument wypłaty
                action: "view-payment-document",
                class: this.getShowPaymentDocumentActionClass(this.paymentsRows[k]),
                enabled: true,
                tooltip: "Zobacz dokument wypłaty",
              },
              {
                text: "Wystaw dokument wypłaty",
                icon: "fas fa-file-invoice",
                action: "create-payment-document",
                class: this.getCreatePaymentDocumentActionClass(this.paymentsRows[k]),
                enabled: true,
              },
            ];
          }

          this.tableData['headers'] = paymentsHeaders;

          this.refreshFieldsAvailableForSearch();
          this.tableData['massActions'] = this.tableMassActions;

          this.tableData['data'] = this.paymentsRows;
          this.refreshTable = true;


        });

      });
    },
    createPaymentsDocuments(paymentsChecked) {
      paymentsHelperMethods.showPaymentDocumentCreateConfirmModal(paymentsChecked).then((response)=>{
        if(response.isConfirmed === false){
          //do nothing
        }else{
          this.refreshPaymentsData().then(()=>{
            this.resetCheckedItems();
          });
        }

      });
    },

    synchronisePayments() {
      paymentsHelperMethods.synchronisePayments().then(() => {
        this.refreshPaymentsData().then(()=>{
          this.resetCheckedItems();
        });
      });
    },
    savePaymentDocumentData(event) {

      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Zapisywanie zmian w dokumencie");

      var updatePayload = {
        paymentDocument: event,
        documentGuid: this.currentPaymentDocumentFormData.guid
      }
      this.paymentsModule.httpUpdateDocuments(updatePayload).then(() => {
        this.showPaymentDocumentModal = false;
        this.currentPaymentDocumentFormData = JSON.parse(JSON.stringify(this.emptyPaymentDocumentFormData));
        this.showPaymentDocumentEditForm = false;
        this.refreshPaymentsData();
      })

    },
    getAmountToPay() {
      return this.checkedItemsPayValueOnPages.toFixed(2);
    },
    exportAndDownload() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Generowanie wydruku PDF...");
      const element = document.getElementById('bank-wire-pdf');
      const opt = {
        margin: 1,
        filename: `Zlecenie_Przewlewu_${this.currentPaymentDocumentFormData.documentNumber || 'dokument'}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
      };

      html2pdf().from(element).set(opt).save();
      this.lazyloaderModule.setDisplayLazyLoader(false);
    },

    exportToPDFText() {

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "a4"
      });
      // Adding the font which supports Polish characters
      var arialNormalFont = jsFonts.ArialNormalJs;
      pdf.addFileToVFS('arial-normal.ttf', arialNormalFont);
      pdf.addFont('arial-normal.ttf', 'arial', 'normal');
      pdf.setFont("arial");

      // Add title
      pdf.setFontSize(16);

      pdf.text("Zlecenie Przelewu Bankowego", 40, 40);


      // Add document details

      pdf.setFontSize(12);
      pdf.text(`Numer dokumentu: ${this.currentPaymentDocumentFormData.documentNumber || '---'}`, 40, 80);
      pdf.text(`Typ dokumentu: ${this.currentPaymentDocumentFormData.documentType || '---'}`, 40, 100);
      pdf.text(`Data wystawienia: ${paymentsHelperMethods.formatDateToLocale(this.currentPaymentDocumentFormData.documentIssueDateTime) || '---'}`, 40, 120);

      // Horizontal separator line
      pdf.line(10, 150, 300, 150);


      // Add payer details
      pdf.setFontSize(14);
      pdf.text("Dane płatnika", 40, 180);
      pdf.setFontSize(12);
      pdf.text(`Nazwa: ${this.currentPaymentDocumentFormData.payerName || '---'}`, 40, 200);
      pdf.text(`Numer konta: ${this.currentPaymentDocumentFormData.payerAccountNumber || '---'}`, 40, 220);
      pdf.text(`Nazwa banku: ${this.currentPaymentDocumentFormData.payerBankName || '---'}`, 40, 240);
      pdf.text(`Adres: ${this.currentPaymentDocumentFormData.payerAddress || '---'}`, 40, 260);
      pdf.text(`NIP: ${this.currentPaymentDocumentFormData.payerNip || '---'}`, 40, 280);
      // Horizontal separator line
      pdf.line(10, 290, 300, 290);


  // Add receiver details
      pdf.setFontSize(14);
      pdf.text("Dane odbiorcy", 40, 320);
      pdf.setFontSize(12);
      pdf.text(`Nazwa: ${this.currentPaymentDocumentFormData.receiverName || '---'}`, 40, 340);
      pdf.text(`Numer konta: ${this.currentPaymentDocumentFormData.receiverAccountNumber || '---'}`, 40, 360);
      pdf.text(`Nazwa banku: ${this.currentPaymentDocumentFormData.receiverBankName || '---'}`, 40, 380);
      pdf.text(`Adres: ${this.currentPaymentDocumentFormData.receiverAddress || '---'}`, 40, 400);
      pdf.text(`NIP: ${this.currentPaymentDocumentFormData.receiverNip || '---'}`, 40, 420);

      // Add payment title
      pdf.setFontSize(12);
      pdf.text(`Kwota: ${this.formatCurrency(this.currentPaymentDocumentFormData.documentValue) || '---'} ${this.currentPaymentDocumentFormData.documentCurrency}`, 40, 460);
      pdf.text(`Słownie: ${paymentsHelperMethods.numberToTextPLN(this.currentPaymentDocumentFormData.documentValue) || '---'} `, 40, 480);
      pdf.text(`Tytuł płatności:`, 40, 500);
      pdf.text(`${this.breakTextAfterEveryNChars(this.currentPaymentDocumentFormData.paymentTitle,60) || '---'}`, 60, 520);

      // pdf.line(0, 540, 1000, 540);
      // Save the PDF
      pdf.save(`Zlecenie_Przewlewu_${this.currentPaymentDocumentFormData.documentNumber || 'dokument'}.pdf`);
    },

    breakTextAfterEveryNChars(text, n) {
      if (text === null) return null;
      return text.match(new RegExp('.{1,' + n + '}', 'g')).join('\n');
    },

    formatCurrency(value) {
      if (value === null) return null;
      return Number(value).toFixed(2);
    },
    editPaymentDocument() {
      this.showPaymentDocumentEditForm =true;
    },
    closeDocumentModal(){
      log.log("closing document modal");
      this.showPaymentDocumentEditForm = false;
    },
    cancelPaymentDocumentEdit(){
      this.showPaymentDocumentEditForm = false;
    },
    updateFilters(filters) {
      this.selectedFilters = filters;
      this.refreshPaymentsData();
    },

    importSelectedSupplierData(suppliers){


      if (suppliers== null || suppliers.length === 0) {
        return;
      }

      this.selectedCentralSuppliersGuidToImport = suppliers[0].guid;
      var selectedSupplierPayload = {
        guid: this.selectedCentralSuppliersGuidToImport
      }
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Importowanie danych wybranego dostawcy centralnego...");

      this.commonModule.httpGetSupplierByGuid(selectedSupplierPayload).then((response) => {
        if (response.status === 200) {
          const importedSupplier = response.data.payload;

          this.currentPaymentDocumentFormData.receiverName = importedSupplier.name;
          this.currentPaymentDocumentFormData.receiverNip = importedSupplier.nip;
          this.currentPaymentDocumentFormData.receiverAccountNumber = importedSupplier.bankAccount;
          this.currentPaymentDocumentFormData.receiverBankName = importedSupplier.bankName;
          this.currentPaymentDocumentFormData.receiverAddress = importedSupplier.address + ", " + importedSupplier.zipcode + " " + importedSupplier.city;

          this.showSelectCentralSupplierModal = false;
          this.showPaymentDocumentEditForm = false;
          // thread sleep for form reload:
          setTimeout(() => {
            this.showPaymentDocumentEditForm = true;
          }, 100);


          this.lazyloaderModule.setDisplayLazyLoader(false)

        }
      })

    },
    exportToCsv(){
      paymentsHelperMethods.exportToFile(this.searchRequest,this.selectedFilters,this.currentPage,this.sortingDirection,this.sortingKey,this.paidStatus,"CSV")
    },
    exportDocumentItemsToCsv(){
      paymentsHelperMethods.exportDocumentItemsToFile(this.currentPaymentDocumentFormData.guid,"CSV");
    }

  },
  watch: {
    currentPage: {
      handler() {
        this.refreshPaymentsData();
      },
      deep: true,
    },


  },
  mounted() {

  },
  created() {
    this.refreshPaymentsData();
    this.paymentsModule.httpGetAvailableBanks().then(()=>{

      //  { key: "santander", name: "Santander Bank Polska S.A.", icon: "images/santander.png" }
      const fetchedAvailableBanks = JSON.parse(JSON.stringify(this.paymentsModule.getAvailableBanks));
      for (let i in fetchedAvailableBanks) {

        this.banks.push({
          key:fetchedAvailableBanks[i].key,
          name:fetchedAvailableBanks[i].name,
          icon: `images/${fetchedAvailableBanks[i].key.toString().toLowerCase()}.png`
        })


      }


    });


    this.commonModule.httpGetLicensedFeatures();
    this.commonModule.httpGetWorkingProfile();


  },
};
</script>

<style scoped>
.payments-stage {
  margin-left: 16px;
  margin-right: 16px;
}

.payments-table-container {
}

.paid-payments-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top:16px;
}

.table-success {
  background-color: #d4edda;
  color: #155724;
}


.table-info {
  background-color: #d4edda;
  color: #152c57;
}

.table-warning {
  background-color: #fff3cd;
  color: #856404;
}

.table-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.paid-payments-checked-items {
  text-align: left;
  margin-left: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
  height:24px;
}

.paid-payments-stage{
  margin-top:8px;
}


</style>
